var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg500(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 195,
    viewBox: "0 0 451 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.099 16.0077V32.2077H193.399V2.10767H119.899V175.508H193.399L374.899 176.608V16.0077H296.099Z",
    fill: "url(#paint0_linear_3_2193)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.299 26.9078H307.699C306.999 26.9078 306.499 26.3078 306.499 25.7078C306.499 25.0078 307.099 24.5078 307.699 24.5078H356.299C356.999 24.5078 357.499 25.1078 357.499 25.7078C357.499 26.3078 356.899 26.9078 356.299 26.9078Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356.299 36.5077H307.699C306.999 36.5077 306.499 35.9077 306.499 35.3077C306.499 34.6077 307.099 34.1077 307.699 34.1077H356.299C356.999 34.1077 357.499 34.7077 357.499 35.3077C357.499 35.9077 356.899 36.5077 356.299 36.5077Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.299 46.1078H307.699C306.999 46.1078 306.499 45.5078 306.499 44.9078C306.499 44.2078 307.099 43.7078 307.699 43.7078H356.299C356.999 43.7078 357.499 44.3078 357.499 44.9078C357.499 45.6078 356.899 46.1078 356.299 46.1078Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M356.299 55.7076H307.699C306.999 55.7076 306.499 55.1076 306.499 54.5076C306.499 53.8076 307.099 53.3076 307.699 53.3076H356.299C356.999 53.3076 357.499 53.9076 357.499 54.5076C357.499 55.2076 356.899 55.7076 356.299 55.7076Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M356.299 65.3077H307.699C306.999 65.3077 306.499 64.7077 306.499 64.1077C306.499 63.4077 307.099 62.9077 307.699 62.9077H356.299C356.999 62.9077 357.499 63.5077 357.499 64.1077C357.499 64.8077 356.899 65.3077 356.299 65.3077Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M356.299 75.0077H307.699C306.999 75.0077 306.499 74.4077 306.499 73.8077C306.499 73.1077 307.099 72.6077 307.699 72.6077H356.299C356.999 72.6077 357.499 73.2077 357.499 73.8077C357.499 74.4077 356.899 75.0077 356.299 75.0077Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.6 11.2078H128.3V17.5078H134.6V11.2078Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.299 11.2078H140.999V17.5078H147.299V11.2078Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.1 11.2078H153.8V17.5078H160.1V11.2078Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.799 11.2078H166.499V17.5078H172.799V11.2078Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.6 26.9077H128.3V33.2077H134.6V26.9077Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.299 26.9077H140.999V33.2077H147.299V26.9077Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.1 26.9077H153.8V33.2077H160.1V26.9077Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M172.799 26.9077H166.499V33.2077H172.799V26.9077Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.6 42.6077H128.3V48.9077H134.6V42.6077Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.299 42.6077H140.999V48.9077H147.299V42.6077Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.1 42.6077H153.8V48.9077H160.1V42.6077Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.799 42.6077H166.499V48.9077H172.799V42.6077Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M255 139.708C249.8 150.908 242.7 150.908 240.4 150.908C234.8 150.908 230.1 147.408 226.6 140.408C222.3 132.008 220.1 119.408 220.1 103.908C220.1 103.708 220.1 103.508 220.1 103.308H190.4C190.4 103.408 190.4 103.608 190.4 103.708C190.6 125.608 195.1 143.908 203.5 156.508C212.2 169.608 224.6 176.508 239.4 176.508C255.7 176.508 269 169.408 277.9 156.108C286.2 143.508 290.5 125.708 290.7 103.308H261C260.9 118.908 258.8 131.508 255 139.708Z",
    fill: "#5571E9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M377.6 139.708C372.4 150.908 365.3 150.908 363 150.908C357.4 150.908 352.7 147.408 349.2 140.408C344.9 132.008 342.7 119.408 342.7 103.908C342.7 103.708 342.7 103.508 342.7 103.308H313C313 103.408 313 103.608 313 103.708C313.2 125.608 317.7 143.908 326.1 156.508C334.8 169.608 347.2 176.508 362 176.508C378.3 176.508 391.6 169.408 400.5 156.108C408.8 143.508 413.1 125.708 413.3 103.308H383.6C383.5 118.908 381.4 131.508 377.6 139.708Z",
    fill: "#5571E9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M291.9 50.2077C283.3 37.0077 270.6 30.1077 255 30.1077C239.6 30.1077 226.7 37.0077 217.5 50.1077C208.5 62.9077 203.8 81.3077 203.7 103.308H233.4C233.5 87.6077 235.8 74.8077 240.2 66.3077C243.8 59.3077 248.5 55.7077 253.9 55.7077C261.5 55.7077 274.3 61.8077 274.3 102.708C274.3 102.908 274.3 103.108 274.3 103.308H304C304 102.808 304 102.408 304 101.908C304.1 80.1077 300 62.6077 291.9 50.2077Z",
    fill: "#5571E9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M414.5 50.2077C405.9 37.0077 393.2 30.1077 377.6 30.1077C362.2 30.1077 349.3 37.0077 340.1 50.1077C331.1 62.9077 326.4 81.3077 326.3 103.308H356C356.1 87.6077 358.4 74.8077 362.8 66.3077C366.4 59.3077 371.1 55.7077 376.5 55.7077C384.1 55.7077 396.9 61.8077 396.9 102.708C396.9 102.908 396.9 103.108 396.9 103.308H426.6C426.6 102.808 426.6 102.408 426.6 101.908C426.7 80.1077 422.6 62.6077 414.5 50.2077Z",
    fill: "#5571E9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3999 172.508C71.4999 172.508 70.5999 171.808 70.4999 170.808L51.6999 3.70763C51.5999 2.70763 52.2999 1.70762 53.3999 1.60762C54.3999 1.50762 55.3999 2.20762 55.4999 3.30762L74.2999 170.408C74.3999 171.408 73.6999 172.408 72.5999 172.508C72.4999 172.508 72.4999 172.508 72.3999 172.508Z",
    fill: "#8C9EA5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.4 172.508C122.5 172.508 121.6 171.808 121.5 170.808L102.7 3.70763C102.6 2.70763 103.3 1.70762 104.4 1.60762C105.4 1.50762 106.4 2.20762 106.5 3.30762L125.3 170.408C125.4 171.408 124.7 172.408 123.6 172.508C123.5 172.508 123.5 172.508 123.4 172.508Z",
    fill: "#8C9EA5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 22.8076H55.4996C54.4996 22.8076 53.5996 22.0076 53.5996 20.9076C53.5996 19.9076 54.3996 19.0076 55.4996 19.0076H106.5C107.5 19.0076 108.4 19.8076 108.4 20.9076C108.4 22.0076 107.6 22.8076 106.5 22.8076Z",
    fill: "#8C9EA5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M107.6 39.4077H57.6998C56.6998 39.4077 55.7998 38.6077 55.7998 37.5077C55.7998 36.5077 56.5998 35.6077 57.6998 35.6077H107.6C108.6 35.6077 109.5 36.4077 109.5 37.5077C109.5 38.6077 108.6 39.4077 107.6 39.4077Z",
    fill: "#8C9EA5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M108.7 56.0075H59.8004C58.8004 56.0075 57.9004 55.2075 57.9004 54.1075C57.9004 53.1075 58.7004 52.2075 59.8004 52.2075H108.7C109.7 52.2075 110.6 53.0075 110.6 54.1075C110.5 55.1075 109.7 56.0075 108.7 56.0075Z",
    fill: "#8C9EA5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 72.6076H61.9996C60.9996 72.6076 60.0996 71.8076 60.0996 70.7076C60.0996 69.7076 60.8996 68.8076 61.9996 68.8076H112.1C113.1 68.8076 114 69.6076 114 70.7076C114 71.7076 113.2 72.6076 112.1 72.6076Z",
    fill: "#8C9EA5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M114 89.2077H63.6002C62.6002 89.2077 61.7002 88.4077 61.7002 87.3077C61.7002 86.3077 62.5002 85.4077 63.6002 85.4077H114C115 85.4077 115.9 86.2077 115.9 87.3077C115.9 88.3077 115 89.2077 114 89.2077Z",
    fill: "#8C9EA5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M115.9 105.708H65.4C64.4 105.708 63.5 104.908 63.5 103.808C63.5 102.808 64.3 101.908 65.4 101.908H115.9C116.9 101.908 117.8 102.708 117.8 103.808C117.8 104.908 116.9 105.708 115.9 105.708Z",
    fill: "#8C9EA5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 7.00757H50.0996C48.1996 7.00757 46.5996 5.40757 46.5996 3.50757C46.5996 1.60757 48.1996 0.00756836 50.0996 0.00756836H104.9C106.8 0.00756836 108.4 1.60757 108.4 3.50757C108.4 5.40757 106.9 7.00757 104.9 7.00757Z",
    fill: "#B0BEC5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3997 172.508C83.2997 172.508 83.2997 172.508 83.1997 172.508C82.1997 172.408 81.3997 171.508 81.4997 170.408L100.3 3.30758C100.4 2.30758 101.3 1.50758 102.4 1.60758C103.4 1.70758 104.2 2.60758 104.1 3.70758L85.2997 170.808C85.1997 171.808 84.3997 172.508 83.3997 172.508Z",
    fill: "#B0BEC5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3997 172.508C32.2997 172.508 32.2997 172.508 32.1997 172.508C31.1997 172.408 30.3997 171.508 30.4997 170.408L49.2997 3.30758C49.3997 2.30758 50.2997 1.50758 51.3997 1.60758C52.3997 1.70758 53.1997 2.60758 53.0997 3.70758L34.2997 170.808C34.1997 171.808 33.3997 172.508 32.3997 172.508Z",
    fill: "#B0BEC5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.299 22.8076H49.2994C48.2994 22.8076 47.3994 22.0076 47.3994 20.9076C47.3994 19.9076 48.1994 19.0076 49.2994 19.0076H100.299C101.299 19.0076 102.199 19.8076 102.199 20.9076C102.199 22.0076 101.399 22.8076 100.299 22.8076Z",
    fill: "#B0BEC5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1994 39.4077H48.2994C47.2994 39.4077 46.3994 38.6077 46.3994 37.5077C46.3994 36.5077 47.1994 35.6077 48.2994 35.6077H98.1994C99.1994 35.6077 100.099 36.4077 100.099 37.5077C100.099 38.6077 99.1994 39.4077 98.1994 39.4077Z",
    fill: "#B0BEC5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0998 56.0075H47.1998C46.1998 56.0075 45.2998 55.2075 45.2998 54.1075C45.2998 53.1075 46.0998 52.2075 47.1998 52.2075H96.0998C97.0998 52.2075 97.9998 53.0075 97.9998 54.1075C97.8998 55.1075 97.0998 56.0075 96.0998 56.0075Z",
    fill: "#B0BEC5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8994 72.6076H43.7994C42.7994 72.6076 41.8994 71.8076 41.8994 70.7076C41.8994 69.7076 42.6994 68.8076 43.7994 68.8076H93.8994C94.8994 68.8076 95.7994 69.6076 95.7994 70.7076C95.6994 71.7076 94.8994 72.6076 93.8994 72.6076Z",
    fill: "#B0BEC5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3 89.2077H41.9C40.9 89.2077 40 88.4077 40 87.3077C40 86.3077 40.8 85.4077 41.9 85.4077H92.3C93.3 85.4077 94.2 86.2077 94.2 87.3077C94.2 88.3077 93.3 89.2077 92.3 89.2077Z",
    fill: "#B0BEC5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4996 105.707H39.9996C38.9996 105.707 38.0996 104.907 38.0996 103.807C38.0996 102.807 38.8996 101.907 39.9996 101.907H90.4996C91.4996 101.907 92.3996 102.707 92.3996 103.807C92.2996 104.907 91.4996 105.707 90.4996 105.707Z",
    fill: "#B0BEC5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6941 163.446C68.7035 157.794 62.6195 151.286 58.4419 143.922C54.302 136.583 52.23 129.04 52.2258 121.29C52.2217 113.541 54.5033 106.277 59.0707 99.4993L82.8162 116.293C79.9079 120.965 79.2202 125.935 80.7529 131.203C82.2857 136.471 85.4643 140.811 90.2888 144.223C94.1333 146.942 98.1252 148.493 102.265 148.876C106.468 149.248 110.479 148.494 114.297 146.614C118.179 144.723 121.532 141.78 124.358 137.784C127.237 133.714 128.902 129.52 129.354 125.203C129.844 120.913 129.194 116.835 127.405 112.968C125.616 109.102 122.794 105.777 118.938 102.994C115.546 100.595 111.755 98.9597 107.565 98.0885C103.412 97.2439 99.5975 97.4013 96.12 98.5607L77.1122 79.2657L125.779 22.0843L196.564 72.1447L182.409 92.1587L131.809 56.3728L108.3 83.2571L108.979 83.7369C113.04 82.3118 117.791 82.1097 123.232 83.1307C128.673 84.1516 133.938 86.4614 139.026 90.06C145.999 94.9914 151.059 101.029 154.205 108.174C157.351 115.318 158.481 122.874 157.596 130.842C156.737 138.773 153.663 146.437 148.374 153.836C142.894 161.665 136.18 167.32 128.232 170.803C120.349 174.275 111.92 175.438 102.947 174.294C94.0388 173.139 85.2877 169.523 76.6941 163.446Z",
    fill: "#5571E9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8002 150.708C41.2002 150.708 34.2002 157.708 34.2002 166.308C34.2002 174.908 41.2002 181.908 49.8002 181.908H181.6V150.708H49.8002Z",
    fill: "#B0BEC5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8002 150.708C41.2002 150.708 34.2002 157.708 34.2002 166.308C34.2002 174.908 41.2002 181.908 49.8002 181.908H181.6V150.708H49.8002Z",
    fill: "url(#paint1_linear_3_2193)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M187.53 180.751C195.503 177.485 199.318 168.373 196.052 160.401C192.786 152.428 183.675 148.612 175.702 151.878C167.729 155.144 163.913 164.256 167.18 172.228C170.446 180.201 179.557 184.017 187.53 180.751Z",
    fill: "#CFD8DC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 177.508C187.786 177.508 192.8 172.493 192.8 166.308C192.8 160.122 187.786 155.108 181.6 155.108C175.415 155.108 170.4 160.122 170.4 166.308C170.4 172.493 175.415 177.508 181.6 177.508Z",
    fill: "#B0BEC5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 177.508C187.786 177.508 192.8 172.493 192.8 166.308C192.8 160.122 187.786 155.108 181.6 155.108C175.415 155.108 170.4 160.122 170.4 166.308C170.4 172.493 175.415 177.508 181.6 177.508Z",
    fill: "url(#paint2_linear_3_2193)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 123.008C24.4004 123.008 17.4004 130.008 17.4004 138.608C17.4004 147.208 24.4004 154.208 33.0004 154.208H164.8V123.008H33.0004Z",
    fill: "#B0BEC5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 123.008C24.4004 123.008 17.4004 130.008 17.4004 138.608C17.4004 147.208 24.4004 154.208 33.0004 154.208H164.8V123.008H33.0004Z",
    fill: "url(#paint3_linear_3_2193)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M175.855 149.642C181.947 143.55 181.947 133.673 175.855 127.581C169.763 121.488 159.886 121.488 153.793 127.581C147.701 133.673 147.701 143.55 153.793 149.642C159.886 155.734 169.763 155.734 175.855 149.642Z",
    fill: "#CFD8DC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M164.801 149.807C170.986 149.807 176.001 144.793 176.001 138.607C176.001 132.422 170.986 127.407 164.801 127.407C158.615 127.407 153.601 132.422 153.601 138.607C153.601 144.793 158.615 149.807 164.801 149.807Z",
    fill: "#B0BEC5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M164.801 149.807C170.986 149.807 176.001 144.793 176.001 138.607C176.001 132.422 170.986 127.407 164.801 127.407C158.615 127.407 153.601 132.422 153.601 138.607C153.601 144.793 158.615 149.807 164.801 149.807Z",
    fill: "url(#paint4_linear_3_2193)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 150.708C7.00001 150.708 0 157.708 0 166.308C0 174.908 7.00001 181.908 15.6 181.908H147.4V150.708H15.6Z",
    fill: "#B0BEC5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M153.472 180.716C161.407 177.359 165.119 168.205 161.762 160.27C158.406 152.335 149.252 148.624 141.317 151.98C133.382 155.337 129.67 164.491 133.027 172.426C136.384 180.361 145.537 184.072 153.472 180.716Z",
    fill: "#CFD8DC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M147.4 177.507C153.586 177.507 158.6 172.493 158.6 166.307C158.6 160.122 153.586 155.107 147.4 155.107C141.215 155.107 136.2 160.122 136.2 166.307C136.2 172.493 141.215 177.507 147.4 177.507Z",
    fill: "#B0BEC5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M147.4 177.507C153.586 177.507 158.6 172.493 158.6 166.307C158.6 160.122 153.586 155.107 147.4 155.107C141.215 155.107 136.2 160.122 136.2 166.307C136.2 172.493 141.215 177.507 147.4 177.507Z",
    fill: "url(#paint5_linear_3_2193)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M259.6 176.408C253.6 176.408 250.7 168.908 255.3 165.008C256 164.408 256.8 163.908 257.6 163.508C260.9 161.808 264.8 161.708 268.3 163.008C270.5 163.808 273 163.308 274.8 161.808C277.4 159.508 281 158.208 284.6 158.108C288 158.008 291.3 158.808 294.6 159.808C297.2 160.708 300.2 159.708 301.8 157.508C308.8 147.908 320.2 141.808 332 139.708C339.1 138.408 346.7 138.408 353.4 141.008C358.5 143.008 363 146.608 365.8 151.208C367.2 153.508 369.9 154.708 372.6 154.208C377.7 153.208 383.5 155.108 387.1 158.908C389.2 161.108 392.4 161.708 395 160.308C397.3 159.008 399.8 158.108 402.5 158.008C405.5 157.908 408.7 159.208 410.7 161.408C412.3 163.208 414.7 163.908 417.1 163.508C418.9 163.208 420.8 163.508 422.4 164.408C422.4 164.408 422.5 164.408 422.5 164.508C428.2 167.808 425.7 176.508 419.1 176.508L259.6 176.408Z",
    fill: "#CFD8DC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M259.6 176.408C253.6 176.408 250.7 168.908 255.3 165.008C256 164.408 256.8 163.908 257.6 163.508C260.9 161.808 264.8 161.708 268.3 163.008C270.5 163.808 273 163.308 274.8 161.808C277.4 159.508 281 158.208 284.6 158.108C288 158.008 291.3 158.808 294.6 159.808C297.2 160.708 300.2 159.708 301.8 157.508C308.8 147.908 320.2 141.808 332 139.708C339.1 138.408 346.7 138.408 353.4 141.008C358.5 143.008 363 146.608 365.8 151.208C367.2 153.508 369.9 154.708 372.6 154.208C377.7 153.208 383.5 155.108 387.1 158.908C389.2 161.108 392.4 161.708 395 160.308C397.3 159.008 399.8 158.108 402.5 158.008C405.5 157.908 408.7 159.208 410.7 161.408C412.3 163.208 414.7 163.908 417.1 163.508C418.9 163.208 420.8 163.508 422.4 164.408C422.4 164.408 422.5 164.408 422.5 164.508C428.2 167.808 425.7 176.508 419.1 176.508L259.6 176.408Z",
    fill: "url(#paint6_linear_3_2193)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M429 169.608H249.5C248 169.608 246.8 170.808 246.8 172.308V179.308C246.8 180.808 248 182.008 249.5 182.008H429C430.5 182.008 431.7 180.808 431.7 179.308V172.308C431.7 170.808 430.5 169.608 429 169.608Z",
    fill: "#455A64"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28.127 113.201L20.627 113.215L20.7742 192.015L28.2742 192.001L28.127 113.201Z",
    fill: "#37474F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 188.708V189.608C15.2998 190.908 16.3998 192.008 17.6998 192.008H31.4998C32.7998 192.008 33.8998 190.908 33.8998 189.608V188.708H15.2998Z",
    fill: "#37474F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3998 185.108H20.7998L15.2998 188.708H33.9998L28.3998 185.108Z",
    fill: "#455A64"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4004 185.108L28.2004 113.208H25.4004L25.6004 185.108L28.3004 188.708V189.608C28.3004 190.908 27.2004 192.008 25.9004 192.008H31.6004C32.9004 192.008 34.0004 190.908 34.0004 189.608V188.708L28.4004 185.108Z",
    fill: "url(#paint7_linear_3_2193)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4998 104.108C33.4998 99.1076 29.3998 95.0076 24.3998 95.0076C19.3998 95.0076 15.2998 99.1076 15.2998 104.108C15.2998 109.108 19.3998 113.208 24.3998 113.208C29.3998 113.208 33.4998 109.108 33.4998 104.108Z",
    fill: "#E53935"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 113.208C29.4 113.208 33.5 109.108 33.5 104.108C33.5 102.508 33.1 101.008 32.3 99.7075L20 112.008C21.3 112.708 22.8 113.208 24.4 113.208Z",
    fill: "url(#paint8_linear_3_2193)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M444.23 115.601L436.93 115.615L437.071 191.315L444.371 191.301L444.23 115.601Z",
    fill: "#37474F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M431.6 188.008V188.808C431.6 190.108 432.7 191.208 434 191.208H447.4C448.7 191.208 449.8 190.108 449.8 188.808V188.008H431.6Z",
    fill: "#37474F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M444.4 184.508H437L431.6 188.008H449.8L444.4 184.508Z",
    fill: "#455A64"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M444.4 184.508L444.2 115.608H441.5L441.7 184.508L444.3 188.008V188.808C444.3 190.108 443.2 191.208 441.9 191.208H447.4C448.7 191.208 449.8 190.108 449.8 188.808V188.008L444.4 184.508Z",
    fill: "url(#paint9_linear_3_2193)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M449.299 106.808C449.299 101.908 445.299 98.0076 440.499 98.0076C435.599 98.0076 431.699 102.008 431.699 106.808C431.699 111.708 435.699 115.608 440.499 115.608C445.399 115.608 449.299 111.608 449.299 106.808Z",
    fill: "#E53935"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M440.499 115.608C445.399 115.608 449.299 111.608 449.299 106.808C449.299 105.208 448.899 103.808 448.199 102.508L436.199 114.508C437.499 115.208 438.899 115.608 440.499 115.608Z",
    fill: "url(#paint10_linear_3_2193)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M439.299 102.508C439.299 103.408 438.599 104.208 437.599 104.208C436.599 104.208 435.899 103.508 435.899 102.508C435.899 101.608 436.599 100.808 437.599 100.808C438.499 100.808 439.299 101.508 439.299 102.508Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M450.885 115.6L14.085 116.416L14.1158 132.916L450.916 132.1L450.885 115.6Z",
    fill: "#F5D100"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8996 116.407L16.3996 132.907H14.0996V123.507L21.2996 116.407H32.8996Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7992 116.307L38.2992 132.907H26.6992L43.0992 116.307H54.7992Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7 116.307L60.2 132.807H48.5L65 116.307H76.7Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5994 116.208L82.0994 132.808H70.3994L86.8994 116.308L98.5994 116.208Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 116.208L104 132.708L92.2998 132.808L108.8 116.208H120.5Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M142.299 116.208L125.899 132.708H114.199L130.699 116.208H142.299Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M164.2 116.107L147.8 132.707H136.1L152.6 116.107H164.2Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M186.1 116.107L169.6 132.607H158L174.4 116.107H186.1Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M208 116.008L191.5 132.608H179.8L196.3 116.008H208Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M229.899 116.008L213.399 132.508L201.699 132.608L218.199 116.008H229.899Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M251.8 115.907L235.3 132.507H223.6L240.1 116.007L251.8 115.907Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M273.7 115.907L257.2 132.407L245.5 132.507L262 115.907H273.7Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M295.499 115.907L279.099 132.407H267.399L283.899 115.907H295.499Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M317.4 115.807L300.9 132.407H289.3L305.8 115.807H317.4Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M339.299 115.807L322.799 132.307H311.199L327.599 115.807H339.299Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M361.2 115.708L344.7 132.308H333L349.5 115.808L361.2 115.708Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M383.099 115.708L366.599 132.208L354.899 132.308L371.399 115.708H383.099Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M405 115.708L388.5 132.208H376.8L393.3 115.708H405Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M426.899 115.607L410.399 132.207H398.699L415.199 115.607H426.899Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M448.7 115.607L432.3 132.107H420.6L437.1 115.607H448.7Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M450.9 123.607L451 132.107H442.5L450.9 123.607Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 132.908L451 132.108L450.9 123.708L14.0996 124.508V132.908Z",
    fill: "url(#paint11_linear_3_2193)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_2193",
    x1: 247.383,
    y1: 175.181,
    x2: 247.383,
    y2: -74.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D7F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_2193",
    x1: 107.922,
    y1: 140.71,
    x2: 107.922,
    y2: 173.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_2193",
    x1: 209.647,
    y1: 166.319,
    x2: 169.165,
    y2: 166.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_2193",
    x1: 91.1276,
    y1: 121.137,
    x2: 91.1276,
    y2: 160.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_2193",
    x1: 192.853,
    y1: 138.576,
    x2: 152.371,
    y2: 138.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_2193",
    x1: 175.476,
    y1: 166.319,
    x2: 134.995,
    y2: 166.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_2193",
    x1: 356.633,
    y1: 149.533,
    x2: 311.003,
    y2: 203.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_2193",
    x1: 4.69604,
    y1: 143.142,
    x2: 66.6437,
    y2: 169.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_2193",
    x1: 26.7011,
    y1: 96.2325,
    x2: 26.7363,
    y2: 114.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_2193",
    x1: 421.68,
    y1: 144.332,
    x2: 481.244,
    y2: 169.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_2193",
    x1: 442.73,
    y1: 99.1541,
    x2: 442.765,
    y2: 117.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_2193",
    x1: 144.5,
    y1: 4.90346,
    x2: 279.119,
    y2: 193.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.65355d1617c6a93fc93572680052f0b7.svg";
export { ForwardRef as ReactComponent };